import { graphql } from 'gql'

export const GET_RICH_PLACEMENT_MULTI_ANCHOR = graphql(`
  query getRichPlacementMultiAnchor($workspaceId: ID!, $canReadFrequencyCapping: Boolean!) {
    workspaceRichPlacementMultianchorConfiguration(workspaceId: $workspaceId) {
      counterStyle
      customStyling
      desktopAdDisplaysBeforeRefresh
      desktopSingleAdViewTime
      displayAfterUserInteractionEnabled
      frequencyCappingEnabled @include(if: $canReadFrequencyCapping)
      fullWidthModeEnabled
      impressionLimit @include(if: $canReadFrequencyCapping)
      mobileAdDisplaysBeforeRefresh
      mobileSingleAdViewTime
      showCloseButtonEnabled
      timeWindow @include(if: $canReadFrequencyCapping)
    }
  }
`)
